(function () {
  if (window.HollyImageVisibility) {
    return;
  }

  var DEFAULT_ROOT_MARGIN = '200px 0px';
  var DEFAULT_THRESHOLD = 0.01;
  var MOBILE_BREAKPOINT = 576;
  var placeholderSrc =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getDatasetValue(img, key) {
    return img.dataset && img.dataset[key] ? img.dataset[key] : '';
  }

  function getDevice(el) {
    var device = getDatasetValue(el, 'hvDevice');
    if (device) {
      return device;
    }
    var ancestor = el.closest ? el.closest('[data-hv-device]') : null;
    if (ancestor) {
      return ancestor.getAttribute('data-hv-device');
    }
    return '';
  }

  function matchesDevice(el) {
    var device = getDevice(el);
    if (!device) {
      return true;
    }
    if (device === 'mobile') {
      return isMobile();
    }
    if (device === 'pc') {
      return !isMobile();
    }
    return true;
  }

  function swapSource(img) {
    if (img.dataset.hvLoaded === 'true') {
      return;
    }
    if (!matchesDevice(img)) {
      return;
    }
    var src = getDatasetValue(img, 'hvSrc');
    var srcset = getDatasetValue(img, 'hvSrcset');
    var sizes = getDatasetValue(img, 'hvSizes');
    var loadedClass = getDatasetValue(img, 'hvLoadedClass');

    if (src) {
      img.src = src;
    }
    if (srcset) {
      img.srcset = srcset;
    }
    if (sizes) {
      img.sizes = sizes;
    }

    var picture =
      img.parentElement && img.parentElement.tagName === 'PICTURE'
        ? img.parentElement
        : null;
    if (picture) {
      var sources = picture.querySelectorAll('source[data-hv-srcset]');
      sources.forEach(function (source) {
        var sourceSrcset = source.dataset.hvSrcset;
        if (sourceSrcset) {
          source.srcset = sourceSrcset;
        }
      });
    }

    img.dataset.hvLoaded = 'true';

    if (loadedClass) {
      img.classList.add(loadedClass);
    }
  }

  function bindImage(img) {
    if (img.dataset.hvBound) {
      return;
    }
    img.dataset.hvBound = 'true';

    var loadedClass = getDatasetValue(img, 'hvLoadedClass');
    if (loadedClass) {
      img.addEventListener('load', function () {
        img.classList.add(loadedClass);
      });
    }
  }

  function setBackground(el) {
    var bg = getDatasetValue(el, 'hvBg');
    var bgMobile = getDatasetValue(el, 'hvBgMobile');
    var isResponsive = Boolean(bgMobile);
    if (el.dataset.hvLoaded === 'true' && !isResponsive) {
      return;
    }
    if (!matchesDevice(el)) {
      return;
    }
    var useMobile = isMobile();
    var mobileSrc = bgMobile || bg;
    var desktopSrc = bg || bgMobile;
    if (useMobile) {
      if (mobileSrc) {
        el.style.setProperty('--bg-image-mobile', 'url("' + mobileSrc + '")');
      }
      el.style.setProperty('--bg-image-pc', '');
      el.style.backgroundImage = 'var(--bg-image-mobile)';
    } else {
      if (desktopSrc) {
        el.style.setProperty('--bg-image-pc', 'url("' + desktopSrc + '")');
      }
      el.style.setProperty('--bg-image-mobile', '');
      el.style.backgroundImage = 'var(--bg-image-pc)';
    }
    el.dataset.hvLoaded = 'true';
  }

  function init(root) {
    var scope = root || document;
    var images = scope.querySelectorAll('img.hv-image');
    var backgrounds = scope.querySelectorAll('.hv-bg');
    if (!('IntersectionObserver' in window)) {
      images.forEach(function (img) {
        bindImage(img);
        swapSource(img);
      });
      backgrounds.forEach(function (el) {
        setBackground(el);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var target = entry.target;
          if (target.tagName === 'IMG') {
            if (!matchesDevice(target)) return;
            bindImage(target);
            swapSource(target);
          } else {
            setBackground(target);
          }
          observer.unobserve(target);
        });
      },
      { rootMargin: DEFAULT_ROOT_MARGIN, threshold: DEFAULT_THRESHOLD },
    );

    images.forEach(function (img) {
      if (!img.getAttribute('src')) {
        img.src = placeholderSrc;
      }
      observer.observe(img);
    });

    backgrounds.forEach(function (el) {
      observer.observe(el);
    });
  }

  window.HollyImageVisibility = {
    init: init,
  };
})();
